export default __webpack_public_path__ + "assets/MyriadPro-BoldIt.ee637692.svg";